__turbopack_context__.v({
  "contentWrpOverflowFix": "Layout-module-scss-module__hocN0G__contentWrpOverflowFix",
  "headerAndContentHolder": "Layout-module-scss-module__hocN0G__headerAndContentHolder",
  "homePageContainer": "Layout-module-scss-module__hocN0G__homePageContainer",
  "layoutChildrenContainer": "Layout-module-scss-module__hocN0G__layoutChildrenContainer",
  "spinnerWrapper": "Layout-module-scss-module__hocN0G__spinnerWrapper",
});
